import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { convertToCSV, downloadCSVFile } from '@lib/common';
import { getDateTime } from '../../utils';
export var downloadAttendeesAsCSV = function downloadAttendeesAsCSV(attendees) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'attendees.csv';
  var headerMapping = arguments.length > 2 ? arguments[2] : undefined;

  if (!attendees || attendees.length === 0) {
    return;
  }

  var headers = ['id', 'firstName', 'lastName', 'fullName', 'email', 'status', 'score', 'gradedPercentage', 'submitTime', 'totalSubmittedSubmission'];
  var defaultHeaderMapping = {
    id: 'ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    fullName: 'Full Name',
    email: 'Email',
    status: 'Status',
    score: 'Score',
    gradedPercentage: 'Graded Percentage',
    submitTime: 'Submit Time',
    totalSubmittedSubmission: 'Total Submissions'
  };

  var mergedHeaderMapping = _objectSpread(_objectSpread({}, defaultHeaderMapping), headerMapping);

  var transformedAttendees = attendees.map(function (attendee) {
    var _attendee$id, _attendee$id$toString, _attendee$report, _attendee$report2, _attendee$report3, _attendee$report4, _attendee$report5;

    return {
      id: ((_attendee$id = attendee.id) === null || _attendee$id === void 0 ? void 0 : (_attendee$id$toString = _attendee$id.toString) === null || _attendee$id$toString === void 0 ? void 0 : _attendee$id$toString.call(_attendee$id)) || attendee.id || '',
      firstName: attendee.firstName || '',
      lastName: attendee.lastName || '',
      fullName: "".concat(attendee.firstName || '', " ").concat(attendee.lastName || '').trim(),
      email: attendee.email || '',
      status: (_attendee$report = attendee.report) !== null && _attendee$report !== void 0 && _attendee$report.isSubmissionPassed ? 'Passed' : 'Failed',
      score: ((_attendee$report2 = attendee.report) === null || _attendee$report2 === void 0 ? void 0 : _attendee$report2.score) || '',
      gradedPercentage: ((_attendee$report3 = attendee.report) === null || _attendee$report3 === void 0 ? void 0 : _attendee$report3.gradedPercentage) || '',
      submitTime: getDateTime(+((_attendee$report4 = attendee.report) === null || _attendee$report4 === void 0 ? void 0 : _attendee$report4.submitTime)) || '',
      totalSubmittedSubmission: ((_attendee$report5 = attendee.report) === null || _attendee$report5 === void 0 ? void 0 : _attendee$report5.totalSubmittedSubmission) || ''
    };
  });
  var csvContent = convertToCSV(transformedAttendees, {
    headers: headers,
    headerMapping: mergedHeaderMapping,
    includeHeaders: true,
    delimiter: ','
  });
  downloadCSVFile(csvContent, filename);
};